/**
 * タグ管理画面のタググループクラス
 *
 * @export TagGroupInfo
 * @class TagGroupInfo
 */
export class TagGroupInfo {
  public check = false;
  constructor(
    public tagGroupId: string,
    public tagGroupName: string,
    public tags: { tagId: string; tagName: string }[]
  ) {}

  get tagNames(){
    return this.tags.map(_=>_.tagName).join(', ');
  }
}
